import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { SubscriptionItem } from 'src/features/subscriptionItems/utils/types';

const RESOURCE = '/subscriptions/subscription/:subscriptionId/subscription-item/:itemId/';

type QueryFnType = typeof queryFn;

interface DTO {
    subscriptionId: string;
    itemId: string;
}
const queryFn = ({ subscriptionId, itemId }: DTO): Promise<SubscriptionItem> => {
    return axios.get(formatResourcePath(RESOURCE, { subscriptionId, itemId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetSubscriptionItem, RESOURCE as SUBSCRIPTION_ITEM_RESOURCE };
